let handler = null;
export const registerImportModeDialog = (fn) => { handler = fn; };
// Modules where "replace" only clears the dates present in the file (old dates are kept)
export const DATE_SCOPED_IMPORTS = [/\/performance\/import(\?|$)/, /\/manpower\/import(\?|$)/, /\/dispatch\/import(\?|$)/, /\/ctb\/import(\?|$)/];
// Resolves {mode: "append"|"replace"} or null when cancelled
export const askImportMode = (filename, url = "") => (handler ? handler(filename, DATE_SCOPED_IMPORTS.some((rx) => rx.test(url))) : Promise.resolve({ mode: "append" }));
